import React, { createContext, useContext, useEffect, useState } from "react";

export interface NavigationInfo {
  redirect?: string;
  isOperationsUser?: boolean;
}

interface NavigationContextType {
  navigation: NavigationInfo | undefined;
  setNavigation: React.Dispatch<React.SetStateAction<NavigationInfo | undefined>>;
  isNavigationReady: boolean;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

interface PropsNavigationProvider {
  children: React.ReactNode;
}

const key = "navigationData";

const NavigationProvider: React.FC<PropsNavigationProvider> = ({ children }) => {
  const [navigation, setNavigation] = useState<NavigationInfo | undefined>(undefined);
  const [isNavigationReady, setIsNavigationReady] = useState(false);

  useEffect(() => {
    if (navigation === undefined) return;
    sessionStorage.setItem(key, JSON.stringify(navigation));
  }, [navigation]);

  useEffect(() => {
    try {
      const storedData = sessionStorage.getItem(key);

      if (storedData && storedData !== "undefined") {
        const storedObject = JSON.parse(storedData);
        setNavigation(storedObject);
      } else {
        setNavigation({});
      }
    } catch (error) {
      console.error("Error al recuperar los datos del sessionStorage:", error);
      setNavigation({});
    } finally {
      setIsNavigationReady(true);
    }
  }, []);

  return (
    <NavigationContext.Provider value={{ navigation, setNavigation, isNavigationReady }}>
      {children}
    </NavigationContext.Provider>
  );
};

const useNavigationContext = () => {
  const context = useContext(NavigationContext);
  if (context === undefined) {
    throw new Error("useNavigationContext debe ser usado dentro de un NavigationProvider");
  }
  return context;
};

export { NavigationProvider, NavigationContext, useNavigationContext };
